module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M4 0h24c2.208 0 4 1.792 4 4v24c0 2.208-1.792 4-4 4H4c-2.208 0-4-1.792-4-4V4c0-2.208 1.792-4 4-4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/checkbox-background.js
// module id = 1057
// module chunks = 14